import { gsap } from 'gsap';

class SpecialitiesAnimation {
	constructor(selector = '.speciality-item') {
		this.selector = selector;
		this.staggerDelay = 0.12;
		this.pathDuration = 0.7;
		this.observer = null;
	}

	init() {
		this.items = document.querySelectorAll(this.selector);

		if (!this.items.length) {
			return;
		}

		this.items.forEach((item) => this.setInitialState(item));

		if (!('IntersectionObserver' in window)) {
			this.items.forEach((item, index) => this.animateItem(item, index));
			return;
		}

		this.createObserver();
		this.items.forEach((item) => this.observer.observe(item));
	}

	createObserver() {
		this.observer = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				const item = entry.target;
				const index = Array.from(this.items).indexOf(item);

				this.animateItem(item, index);
				observer.unobserve(item);
			});
		}, {
			threshold: 0.25,
			rootMargin: '0px 0px -10% 0px',
		});
	}

	setInitialState(item) {
		const svg = item.querySelector('.speciality-item__icon svg');
		const path = svg?.querySelector('path');
		const circle = svg?.querySelector('circle');

		if (!path || !circle) {
			return;
		}

		const pathLength = path.getTotalLength();
		const baseRadius = Number.parseFloat(circle.getAttribute('r')) || 12;

		item.dataset.pathLength = String(pathLength);
		item.dataset.baseRadius = String(baseRadius);

		gsap.set(path, {
			opacity: 0.25,
			strokeDasharray: pathLength,
			strokeDashoffset: pathLength,
		});

		gsap.set(circle, {
			opacity: 1,
			attr: { r: 0.001 },
		});

		circle.classList.remove('is-pulsing');
	}

	animateItem(item, index) {
		const svg = item.querySelector('.speciality-item__icon svg');
		const path = svg?.querySelector('path');
		const circle = svg?.querySelector('circle');

		if (!path || !circle) {
			return;
		}

		const pathLength = Number.parseFloat(item.dataset.pathLength) || path.getTotalLength();
		const baseRadius = Number.parseFloat(item.dataset.baseRadius) || Number.parseFloat(circle.getAttribute('r')) || 12;

		const timeline = gsap.timeline({ delay: index * this.staggerDelay });

		timeline
			.to(path, {
				strokeDashoffset: 0,
				duration: this.pathDuration,
				ease: 'power2.out',
			})
			.to(circle, {
				attr: { r: baseRadius * 1.2 },
				duration: 0.2,
				ease: 'power2.out',
				yoyo: true,
				repeat: 1,
			}, '-=0.2')
            .call(() => {
                circle.setAttribute('r', String(baseRadius));
                circle.classList.add('is-pulsing');
            })
            .to(path, {
                strokeDasharray: '6, 0',
                duration: 0.2,
            })
            .to(path, {
                opacity: 1,
                strokeDasharray: '6, 3',
                duration: 0.2,
            });
	}
}

export default new SpecialitiesAnimation();
